import React, { useState } from "react";
import { Collapse } from "@mui/material";

import {
    GuideBlock,
    GuideGrid,
    GuideList,
    GuideTitle,
    InlineCode,
    SectionButtonGhost,
    SectionCard,
    SectionHeader,
    SectionTitle,
} from "./Styled";

const AuditFilterGuide: React.FC = () => {
    const [open, setOpen] = useState(false);

    return (
        <SectionCard>
            <SectionHeader>
                <SectionTitle>Hướng dẫn bộ lọc / Filter guide</SectionTitle>
                <SectionButtonGhost onClick={() => setOpen((s) => !s)}>
                    {open ? "Ẩn" : "Xem"}
                </SectionButtonGhost>
            </SectionHeader>
            <Collapse in={open}>
                <GuideGrid>
                    <GuideBlock>
                        <GuideTitle>Action / Hành động</GuideTitle>
                        <div>
                            Format:{" "}
                            <InlineCode>app.model.created|updated|deleted</InlineCode>
                        </div>
                        <GuideList>
                            <li>
                                <InlineCode>materials.material.created</InlineCode>
                            </li>
                            <li>
                                <InlineCode>product_flow.saleorder.updated</InlineCode>
                            </li>
                            <li>
                                <InlineCode>products.producttransaction.created</InlineCode>
                            </li>
                        </GuideList>
                    </GuideBlock>

                    <GuideBlock>
                        <GuideTitle>Entity types</GuideTitle>
                        <div>
                            Format: <InlineCode>app.model</InlineCode>
                        </div>
                        <GuideList>
                            <li>
                                <InlineCode>materials.materialsimport</InlineCode>,{" "}
                                <InlineCode>materials.materialsexport</InlineCode>
                            </li>
                            <li>
                                <InlineCode>products.productimportinfo</InlineCode>,{" "}
                                <InlineCode>products.productsexport</InlineCode>
                            </li>
                            <li>
                                <InlineCode>product_flow.saleorder</InlineCode>,{" "}
                                <InlineCode>product_flow.saleorderitem</InlineCode>
                            </li>
                            <li>
                                <InlineCode>materials.materialtransaction</InlineCode>,{" "}
                                <InlineCode>products.producttransaction</InlineCode>
                            </li>
                            <li>
                                <InlineCode>materials.materialbatch</InlineCode>,{" "}
                                <InlineCode>materials.materialrequest</InlineCode>
                            </li>
                        </GuideList>
                    </GuideBlock>

                    <GuideBlock>
                        <GuideTitle>Code / Mã</GuideTitle>
                        <div>Root/entity code from metadata.</div>
                        <GuideList>
                            <li>
                                <InlineCode>SO-001</InlineCode>
                            </li>
                            <li>
                                <InlineCode>MR-2024-05</InlineCode>
                            </li>
                            <li>
                                <InlineCode>EX-123</InlineCode>
                            </li>
                        </GuideList>
                    </GuideBlock>

                    <GuideBlock>
                        <GuideTitle>Actor / Request</GuideTitle>
                        <GuideList>
                            <li>
                                actor_email: partial match ok (ex{" "}
                                <InlineCode>manager@</InlineCode>)
                            </li>
                            <li>
                                actor_id: user id (ex <InlineCode>42</InlineCode>)
                            </li>
                            <li>
                                request_ip/path/user_agent: partial match ok
                            </li>
                            <li>request_id: UUID</li>
                            <li>
                                is_root: <InlineCode>true</InlineCode> or{" "}
                                <InlineCode>false</InlineCode>
                            </li>
                        </GuideList>
                    </GuideBlock>

                    <GuideBlock>
                        <GuideTitle>Date range</GuideTitle>
                        <div>Use the date picker. Backend compares UTC.</div>
                    </GuideBlock>

                    <GuideBlock>
                        <GuideTitle>Tips</GuideTitle>
                        <GuideList>
                            <li>Use action + code for specific workflow.</li>
                            <li>Use root_entity_type + root_entity_id for lifecycle.</li>
                            <li>Use request_id to group all changes.</li>
                        </GuideList>
                    </GuideBlock>
                </GuideGrid>
            </Collapse>
        </SectionCard>
    );
};

export default AuditFilterGuide;
